var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin__content main-stage__content container-fluid"},[_c('GridPlaylistShow',{attrs:{"video-assets":_vm.videoAssets,"selected-video-asset":_vm.selectedVideoAsset,"player-visible":_vm.playerVisible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }